import React from 'react';
import styled from 'styled-components';
import useTranslate from '../../../i18n/useTranslate';

interface DotFallingProps {
  color?: string;
}
const DotFalling = ({ color = '#ffffff' }: DotFallingProps) => {
  const { i18n } = useTranslate();
  return (
    <Container aria-label={i18n('base_loading')}>
      <Dot color={color} delay={0} />
      <Dot color={color} delay={0.2} />
      <Dot color={color} delay={0.4} />
    </Container>
  );
};
interface DotProps {
  delay: number;
  color: string;
}
const Dot = styled.div<DotProps>`
  width: 0.8ch;
  height: 0.8ch;
  border-radius: 100%;
  background-color: ${(props) => props.color};
  animation: dotFalling 3s infinite linear;
  animation-delay: ${(props) => `${props.delay}s`};

  @keyframes dotFalling {
    0% {
      transform: translateY(-200%);
    }
    25%,
    50%,
    75% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(200%);
    }
  }
`;

const Container = styled.div`
  display: flex;
  gap: 0.3ch;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  width: 100%;
  height: 100%;
`;
export default DotFalling;
